import './App.css';

import { useEffect } from "react";
import { Routes, Route } from "react-router-dom";


import { Header } from "./components/header/Header";
import { Footer } from "./components/footer/Footer";
import { Home } from "./components/home/Home";
import { Error404 } from "./components/home/Error404";
import { Cookies } from "./components/terms-and-privacy/Cookies";
import { Privacy } from "./components/terms-and-privacy/Privacy";
import { Contact } from "./components/home/contact/Contact";
import { Calculator } from "./components/calculator/Calculator";
import { Products } from "./components/products/Products";
import { Catalogs } from "./components/catalogs/Catalogs";
import { Colors } from "./components/colors/Colors";
import { Details } from "./components/products/Details";
import { Prices } from "./components/catalogs/Prices";
import { Samples } from "./components/colors/Samples";
import { Gallery } from "./components/gallery/Gallery";

// Google Ads conversion tracking. Replace the three placeholders with the values
// from Google Ads -> Goals -> Conversions -> (action) -> Tag setup.
// The same AW- id must also be set in public/index.html.
const ADS_ID = "AW-17821975507";
const PHONE_CLICK_LABEL = "JsLKCJOYlaAdENOHl7JC";
const EMAIL_CLICK_LABEL = "jsQJCJaYlaAdENOHl7JC";

function App() {
    useEffect(() => {
        const onClick = (e) => {
            const link = e.target.closest('a[href^="tel:"], a[href^="mailto:"]');
            if (!link || typeof window.gtag !== "function") return;
            const label = link.href.startsWith("tel:") ? PHONE_CLICK_LABEL : EMAIL_CLICK_LABEL;
            window.gtag("event", "conversion", { send_to: `${ADS_ID}/${label}` });
        };
        document.addEventListener("click", onClick);
        return () => document.removeEventListener("click", onClick);
    }, []);

    return (
        <div className="boxed_wrapper">
            <Header />
            <Routes>
                <Route path="/" element={<Home />} />

                <Route path="/Cookies" element={<Cookies />} />
                <Route path="/Privacy" element={<Privacy />} />
                <Route path="/Contact" element={<Contact />} />
                <Route path="/Calculator" element={<Calculator />} />
                <Route path="/Products" element={<Products />} />
                <Route path="/Catalogs" element={<Catalogs />} />
                <Route path="/Colors" element={<Colors />} />
                <Route path="/Gallery" element={<Gallery />} />
                <Route path="/Products/Details/:productId" element={<Details />} />
                <Route path="/Catalogs/Prices/:catalogId" element={<Prices />} />
                <Route path="/Colors/Samples/:modelId" element={<Samples />} />

                <Route path="/*" element={<Error404 />} />
            </Routes>
            <Footer />
        </div>
    );
}

export default App;